import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/food-long-description"

export const getFoodLongDescription = async foodLongDescriptionId => {
  const response = await farasod.get(`${endpoint}/${foodLongDescriptionId}`)

  return response.data
}

export const getFoodLongDescriptions = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const createFoodLongDescription = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const updateFoodLongDescription = async (foodLongDescriptionId, data) => {
  const response = await farasod.patch(`${endpoint}/${foodLongDescriptionId}`, data)

  return response.data
}

export const deleteFoodLongDescription = async foodLongDescriptionId => {
  const response = await farasod.delete(`${endpoint}/${foodLongDescriptionId}`)

  return response.data
}